'use client';

import { useConfig } from 'statsig-react';

import usePathnameWithoutLocale from '@/app/hooks/usePathnameWithoutLocale';

import type {
  GenericEyebrowProps,
  VectorImageEyebrowProps,
} from '../EyebrowMessage';
import {
  AffiliateMessage,
  GenericEyebrow,
  VectorImageEyebrow,
} from '../EyebrowMessage';
import type { EyebrowConfig, EyebrowProps } from '../types';

const useEyebrowProps = (): EyebrowProps => {
  const { config: saleGen3Config } = useConfig('eyebrow_gen3'); // safe to remove after 11/4/2024
  const { config } = useConfig('eyebrow');

  const saleGen3Value = saleGen3Config.value as EyebrowConfig; // safe to remove after 11/4/2024
  const eyebrowConfig = config.value as EyebrowConfig;

  const hasVectorImage = eyebrowConfig.vectorImage !== undefined;

  const activeGen3EyebrowConfig = Object.keys(saleGen3Config.value).length > 0; // safe to remove after 11/4/2024
  const activeEyebrowConfig = Object.keys(config.value).length > 0;

  const className =
    eyebrowConfig.className ?? 'bg-sandstone-200 text-sandstone-500';

  // Display the hidden afilliate eyebrow by default
  const DEFAULT = {
    displayMessage: AffiliateMessage,
    className: 'hidden',
    id: 'partner_eyebrow',
  };
  const pathnameWithoutLocale = usePathnameWithoutLocale();

  // organize by pathname and statsig config
  const gen3SaleRoutes = saleGen3Value.routes; // safe to remove after 11/4/2024
  const routes = eyebrowConfig.routes;

  const activeConfigPathGen3 = gen3SaleRoutes?.length
    ? gen3SaleRoutes.includes(pathnameWithoutLocale)
    : pathnameWithoutLocale === '/'; // safe to remove after 11/4/2024
  const activeConfigPath = routes?.length
    ? routes.includes(pathnameWithoutLocale)
    : pathnameWithoutLocale === '/';

  // safe to remove after 11/4/2024
  if (activeGen3EyebrowConfig && activeConfigPathGen3) {
    return {
      //Default class name styles for the eyebrow if no classname in config is provided
      className,
      displayMessage: () => (
        <GenericEyebrow
          {...(saleGen3Config.value as unknown as GenericEyebrowProps)}
        />
      ),
    };
  }

  if (activeEyebrowConfig && activeConfigPath) {
    return {
      //Default class name styles for the eyebrow if no classname in config is provided
      className: className,
      displayMessage: () =>
        hasVectorImage ? (
          <VectorImageEyebrow
            {...(config.value as unknown as VectorImageEyebrowProps)}
          />
        ) : (
          <GenericEyebrow
            {...(config.value as unknown as GenericEyebrowProps)}
          />
        ),
    };
  }

  // Display the hidden affiliate eyebrow by default
  if (pathnameWithoutLocale === '/product/rings') {
    return DEFAULT;
  }

  return { className: 'hidden', displayMessage: () => <></> };
};

export default useEyebrowProps;
